import { render, staticRenderFns } from "./DeliveryData.vue?vue&type=template&id=e3d9da6a&scoped=true&"
import script from "./DeliveryData.vue?vue&type=script&lang=js&"
export * from "./DeliveryData.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryData.vue?vue&type=style&index=0&id=e3d9da6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d9da6a",
  null
  
)

export default component.exports